import initialState from './initialState';

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_TASK':
      return { ...state, dashboard: { ...state.dashboard, currentTask: action.payload } };
    case 'SET_PROGRESS':
      return { ...state, project: { ...state.project, progress: action.payload } };
    case 'TOGGLE_TODO':
      return { ...state, project: { ...state.project, todos: state.project.todos.map((t) => (t.id === action.payload ? { ...t, done: !t.done } : t)) } };
    default:
      return state;
  }
};

export default reducer;